/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./index.scss";

import { duration } from "utils";
// ui
import { Row, Col } from "antd";
// animation
import { Fade } from "react-reveal";

import { Player, BigPlayButton } from "video-react";

// images
import IntroImage from "../../../assets/icons/layout.svg";
// import YoutubeImage from "../../../assets/images/bg-introduction.png";
import IntroPrecog from "assets/images/intro-precog.png";
import IntroVideo from "assets/videos/Intro-video-precog.webm";
// import IntroVideo from "assets/videos/introduction.mp4";

const IntroducingPrecog = (props) => {
  return (
    <div className="introducing" ref={props.introRef}>
      <div className="introducingContent customContainer">
        <Fade bottom duration={duration}>
          <div className="viewImage">
            <img src={IntroImage} alt="" />
          </div>
        </Fade>

        <Fade bottom duration={duration}>
          <h1>Introducing Precog</h1>
        </Fade>

        <Fade bottom duration={duration}>
          {/* <div className="mainImage">
            <img alt="" src={IntroPrecog} />
          </div> */}
          <div className="mainVideo">
            <Player
              //  poster={IntroPrecog}
              light={IntroPrecog}
              src={IntroVideo}
            >
              <BigPlayButton position="center" />
            </Player>
          </div>
        </Fade>

        <Row gutter={100}>
          <Col md={12} xs={24}>
            <Fade bottom duration={duration}>
              <div className="boxInfo">
                <h3 style={{ textTransform: "uppercase" }}>
                  Basis Aggregator Protocol
                </h3>
                <p>
                  Precog.finance is a new decentralized ecosystem that aims to
                  leverage on price differences between exchange pairs (eg. BTC
                  and USD), but across several exchanges. The ecosystem
                  automatically exploits pricing inefficiencies between spot and
                  futures cryptocurrency markets.
                </p>
              </div>
            </Fade>
          </Col>
          <Col md={12} xs={24}>
            <Fade bottom duration={duration}>
              <div className="boxInfo">
                <h3>How it works</h3>
                <p>
                  {`Similar to a traditional “cash and carry” arbitrage investment strategy, the Precog.finance contract evaluates the spot and “carrying cost” of a cryptocurrency, then compares the cost against a future value premium. If the FVP > SCC, then Precog.finance executes and acquires the forward sell, locking in the value difference between the spot and future price, making a profit.`}{" "}
                </p>
              </div>
            </Fade>
          </Col>
          <Col md={12} xs={24}>
            <Fade bottom duration={duration}>
              <div className="boxInfo">
                <h3>The token </h3>
                <p>
                  Instead of jumping around various exchanges trying to
                  establish the biggest yield and best DeFi project, individuals
                  can invest in Precog.finance by purchasing a token.
                </p>
              </div>
            </Fade>
          </Col>
          <Col md={12} xs={24}>
            <Fade bottom duration={duration}>
              <div className="boxInfo">
                <h3>How you make money</h3>
                <p>
                  Users buy tokens. Precog.finance automatically trades futures/
                  arbitrage and returns is inserted back into the token and the
                  token value increased. The Yield is is calculated at the end.
                  The token gains in value from the profit traded by the pool.
                </p>
              </div>
            </Fade>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default IntroducingPrecog;
